import MaterialTable from 'material-table';
import React from 'react';
import { SmartAvatar } from 'src/views/harvesting/fruit-profile/components/smart-avatar';
import { useFirestoreCollectionData } from 'reactfire';
import { useFirestore } from 'reactfire';
import { collection, query, where } from 'firebase/firestore';
import { FruitPropsType } from 'src/views/harvesting/fruit-profile/model';

import { FRUIT_LOCK_FILTER_DATE_UNIX } from 'src/views/harvesting/fruit-profile/fruit-profile-single/utils/smart-filtering';

export const FishesList = () => {
  const db = useFirestore();

  const usersQuery = query(
    collection(db, 'fishes'),
    where('version','==',3),
    where('createdAt.seconds', '<', FRUIT_LOCK_FILTER_DATE_UNIX),
    where('harvestland', '==', true),
  );
  const { data:fishlist } = useFirestoreCollectionData(usersQuery, {
    idField: 'id', // this field will be added to the object created from each document
  });
  return (
    <>
      <MaterialTable
        columns={[
          {
            title: 'Profile Pic',
            field: 'image',
            render: (rowData) => <SmartAvatar fruit={rowData} />,
          },
          { title: 'Name', field: 'name' },
          { title: 'Other Information', field: 'others' },
          { title: 'Pastor', field: 'pastor' },
        ]}
        data={fishlist as FruitPropsType[]}
        title="Demo Title"
        options={{
          pageSize: 20,
        }}
      />
    </>
  );
};
